module.exports = "https://r.nearpod.com/assets/media/image/clock-79ce9bb9b5b54a88633b1d651d22f78f.svg";